formsModule = angular.module('formsModule')
formsModule.controller 'ProviderErrorsController', ($scope, $state, $stateParams, $log) ->
  $log.log 'ProviderErrorsController'